import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { FormControlService } from './../../shared/services/form-control.service';
import { Textbox } from './../../models/editors/textbox.model';
import { ApiService } from './../../shared/services/api.service';
import { AlertService } from './../../shared/services/alert.service';
import { InlineFormBase } from './../../shared/components/base/inline-form/inline-form.base.component';
import { FormField } from './../../models/forms/formField.model';
import { ContainedFormFields } from './../../models/editors/contained-form-fields.model';

@Component({
  selector: 'swb-estate-formfields',
  templateUrl: './../../shared/components/base/inline-form/inline-form.base.component.html',
  providers: [FormControlService]
})

export class EstateFormfieldsComponent extends InlineFormBase<FormField> implements OnInit {

  public url = 'estate-formfields';

  public headerTitle = 'Formulář u realit';
  public get fieldsConfig(): Array<any> {
    return [
      new ContainedFormFields({
        key: 'estateformfields',
        label: 'Formulářová pole',
        validators: [],
        containedMultilang: true
      })
    ];
  }

  constructor(
    _formService: FormControlService,
    _apiService: ApiService,
    _alertService: AlertService
  ) {
    super(
      _formService,
      _apiService,
      _alertService
    );
  }

}
